import React, { useState } from 'react';
import {
    Box, Container, createStyles, Dialog, Grid, makeStyles,
    TextField, Theme, IconButton, FormHelperText
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import useCommonApi from '../../api/useCommonApi';
import CloseIcon from '@material-ui/icons/Close';
import LoadingDialog from '../controls/LoadingDialog';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { Defaults } from "../../defaults/Defaults";
import SubmitButton from '../controls/SubmitButton';
import { Search } from '@material-ui/icons';
import swal from 'sweetalert2'
import { Autocomplete } from '@material-ui/lab';
import Help, { IHelp } from '../help/Help';
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';

interface Props {
    abierto: boolean
    confirmar: () => void
    cerrar: () => void
    maxWidth?: 'lg' | 'md' | 'sm' | 'xl'
    cliente: any
    usuario: any
    distribuidor?: any
    setContacto: (direccion: any) => void
    ayuda?: IHelp
}





const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        principal: {
            backgroundColor: "#fff",
            margin: "0px",
            padding: "10px",
        },
        container: {
            backgroundColor: "#e5e5e5",
        },
        text: {
            backgroundColor: "#fff",
        },
        div_rfc: {
            width: '100%',
        },
        label: {
            fontSize: '18px',
        },
        direccion: {
            fontSize: '14px',
            fontWeight: 600
        },
        icon: {
            width: "40px",
            height: "40px",
            minWidth: "40px",
            borderRadius: "20px",
            backgroundColor: "#19754e",
            color: "#fff",
            textAlign: "center",
            paddingTop: "5px"
        },
        actions: {
            textAlign: "center",
            width: "100%",
            display: "block",
            padding: "30px 0px",
        },
        button: {

            backgroundColor: "#00653b",
            color: "#fff"
        },
        table: {
            minWidth: 650,
        },
        padding: {
            padding: "10px 0px"
        },
        filters: {
            backgroundColor: "#ececec",
            boxShadow: "none",
            verticalAlign: "middle",
            paddingTop: "30px"
        },
        textField: {
            marginRight: theme.spacing(1),
            backgroundColor: "#fff"
        },
    }),
);


const AgregarContacto = ({ abierto, cerrar, confirmar, maxWidth, cliente, usuario, distribuidor, setContacto, ayuda }: Props) => {
    
    const classes = useStyles();
    const apiSource = useCommonApi();
    const [distribuidorId, setDistribuidorId] = useState('');
    const [clienteDistribuidorId, setClienteDistribuidorId] = useState(0);
    const [nombre, setNombre] = useState('');
    const [puesto, setPuesto] = useState('');
    const [departamento, setDepartamento] = useState('');
    const [correo, setCorreo] = useState('');
    const [telefono, setTelefono] = useState('');
    const [formularioValido, setFormularioValido] = useState(true);
    const [showLoading, setLoading] = useState(false);
    const [disabledDistribuidor, setDisabledDistribuidor] = useState(false);

    const [distribuidores, setDistribuidores] = useState<any[]>([]);
    const [showDistribuidores, setShowDistribudores] = useState(false);

    React.useEffect(() => {
        if (distribuidor !== undefined) {
            setDisabledDistribuidor(true);
            setDistribuidorId(distribuidor.nombre);
            buscaDistribuidorCliente();
        }
        else {
            setDisabledDistribuidor(false);
        }


    }, []);

    const validarContacto = () => {

        setFormularioValido(false);

        if (distribuidorId !== '' && nombre !== '' && telefono !== '') {
            setFormularioValido(true);
            setLoading(true);
            guardaContacto().then(response => {
                setLoading(false);
                setContacto({
                    id: response.clienteDistribuidorContactoID,
                    nombre: response.nombreClienteDistribuidorContacto,
                    puesto: response.puesto,
                    departamento: response.departamento,
                    telefono: response.telefono,
                    correo: response.correo,
                    clienteDistribuidorID: response.clienteDistribuidorID
                });


                swal.fire({
                    titleText: traducirMessage(14), //'¡Exitoso!',
                    text: traducirMessage(53), // "El contacto se ha guardado exitosamente.",
                    type: 'success',
                });
                confirmar();
            }).catch(ex => {
                swal.fire({
                    titleText: traducirMessage(272), // '¡Error!',
                    text: traducirMessage(209), // "Ocurrio un error al guardar el contacto.",
                    type: 'error',
                });
                setLoading(false);
            });
        }
    };

    const guardaContacto = async () => {
        const result = await apiSource.postAsync<any>("cliente-distribuidor-contacto", setContactoDto());
        return result;
    };


    const setContactoDto = (): any => {
        return {
            clienteID: cliente.id,
            clienteDistribuidorID: distribuidor !== undefined ? distribuidor.clienteDistribuidorID ? distribuidor.clienteDistribuidorID : distribuidor.clienteDistribuidorId : clienteDistribuidorId,
            clienteDistribuidorContactoID: 0,
            nombreClienteDistribuidorContacto: nombre,
            puesto: puesto,
            medioContactoID: 0,
            telefono: telefono,
            correo: correo,
            nombrePCMod: '',
            departamento: departamento,
            tipoTelefonoId: 0,
            ladaId: 0,
            auditFecha: undefined,
            auditUsuarioID: usuario.id
        }
    };

    const buscaDistribuidorCliente = () => {


        setLoading(true);
        getDistribuidorCliente().then(response => {
            setDistribuidores(response);
            if (response.length) {
                setShowDistribudores(true);
            }
            else {
                setNombre('');
                setTelefono('');
                setClienteDistribuidorId(0);
                setShowDistribudores(false);
            }

            /* if (response.length) {
                 setNombre(response[0].nombreClienteDistribuidor);
                 setTelefono(response[0].telefono !== null ? response[0].telefono : '');
                 setClienteDistribuidorId(response[0].clienteDistribuidorID);
             }*/
            setLoading(false);
        });

    }

    const handleChangeDistribuidor = (value: any) => {


        //    setNombre(value.nombreClienteDistribuidor);
        //  setTelefono(value.telefono);
        if (!value) {
            setShowDistribudores(false);
            return;
        }
        setClienteDistribuidorId(value.clienteDistribuidorID);


        //  setDistribuidorId(distribuidorId);
    }

    const getDistribuidorCliente = async () => {
        const result = await apiSource.obtenerAsync<any>("cliente-distribuidor/by-filtro/" + cliente.id, {
            nombre: distribuidorId,
            distribuidor: 0
        });
        return result;
    };

    const handleNombre = (data: any) => {

        let value = data;
        value = value.replace(/[^a-zA-Z ]/g, "");
        setNombre(value);
    }

    const handleDepartamento = (data: any) => {

        let value = data;
        value = value.replace(/[^a-zA-Z ]/g, "");
        setDepartamento(value);
    }

    const handlePuesto = (data: any) => {

        let value = data;
        value = value.replace(/[^a-zA-Z ]/g, "");
        setPuesto(value);
    }


    return (<>
        <Dialog open={abierto} maxWidth={maxWidth ? maxWidth : "md"} fullWidth={true} onClose={cerrar}>
            <DialogTitle id="simple-dialog-title">
                <Box display="flex" alignItems="center">
                    <Box>
                        <Help comments={traducirMessage(230)} customStyle={{ top: "-40px", right: "-25px" }} />
                    </Box>
                    <Box flexGrow={1} textAlign="center">
                        {/* Nuevo Contacto */
                            traducirLabel(213)}
                    </Box>
                    <Box>
                        <IconButton onClick={cerrar}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </Box>
            </DialogTitle>
            <DialogContent dividers>
                <DialogContentText>

                    <Container maxWidth="xl" className={classes.filters} >

                        <Grid container spacing={3} >
                            <Grid item xs={2} >
                                <div className={classes.label}>
                                    {/* Distribuidor */
                                        traducirLabel(98)}
                                </div>
                            </Grid>

                            <Grid item xs={8}>

                                {!showDistribuidores &&
                                    <TextField id="outlined-basic" variant="outlined" className={classes.textField}
                                        value={distribuidorId} size="small" fullWidth required
                                        disabled={disabledDistribuidor}
                                        onChange={e => setDistribuidorId(e.target.value)} />
                                }


                                {showDistribuidores &&
                                    <Autocomplete style={{ backgroundColor: "#fff" }}
                                        options={distribuidores}
                                        getOptionLabel={(option) => option.nombreClienteDistribuidor}
                                        onChange={(event, value) => handleChangeDistribuidor(value)}
                                        renderInput={(params) => <TextField {...params} label={traducirLabel(327)}
                                            variant="outlined" />
                                        /* Seleccionar */}
                                    />
                                }
                                <FormHelperText error>
                                    {distribuidorId === '' && !formularioValido ? traducirLabel(126) : '' /* Este campo es requerido. */}
                                </FormHelperText>
                            </Grid>
                            <Grid item xs={2} >

                                {!disabledDistribuidor &&
                                    <Button className={classes.icon} color="primary" variant="contained" onClick={() => buscaDistribuidorCliente()}>
                                        <Search />
                                    </Button>
                                }


                            </Grid>
                        </Grid>

                    </Container>

                    <br />
                    <Container maxWidth="xl" fixed >
                        <form noValidate autoComplete="off">
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                </Grid>
                                <Grid item xs={12}>
                                    <ValidatorForm onSubmit={validarContacto}>
                                        <TextValidator
                                            label={traducirLabel(201)} // "Nombre"
                                            value={nombre}
                                            name="nombre"
                                            onChange={e => handleNombre(e.target.value)}
                                            variant="outlined"
                                            fullWidth
                                            validators={['required']}
                                            errorMessages={[traducirLabel(126)]}
                                        />
                                        <br />

                                        <TextValidator
                                            label={traducirLabel(243)} // "Puesto"
                                            value={puesto}
                                            name="puesto"
                                            onChange={e => handlePuesto(e.target.value)}
                                            variant="outlined"
                                            fullWidth
                                        />
                                        <br />
                                        <TextValidator
                                            label={traducirLabel(78)} // "Departamento"
                                            value={departamento}
                                            name="departamento"
                                            onChange={e => handleDepartamento(e.target.value)}
                                            variant="outlined"
                                            fullWidth
                                        />
                                        <br />
                                        <TextValidator
                                            label={traducirLabel(290)} // "Teléfono"
                                            value={telefono}
                                            name="telefono"

                                            onChange={e => setTelefono(e.target.value)}
                                            variant="outlined"
                                            fullWidth
                                            InputProps={{
                                                inputProps: { maxLength: 15 },
                                            }}
                                            validators={['required', 'isNumber']}
                                            errorMessages={[traducirLabel(126), traducirLabel(293)]}
                                        />
                                        <br />
                                        <TextValidator
                                            label={traducirLabel(54)} // "Correo"
                                            value={correo}
                                            name="email"
                                            onChange={e => setCorreo(e.target.value)}
                                            variant="outlined"
                                            fullWidth
                                            validators={['isEmail']}
                                            errorMessages={[traducirLabel(55)]}
                                        />
                                        {/* Guardar */}
                                        <SubmitButton label={traducirButton(12)} />
                                    </ValidatorForm>
                                </Grid>

                            </Grid>

                        </form>
                    </Container>


                </DialogContentText>

            </DialogContent>

        </Dialog>
        {showLoading &&
            <>
                {/* Procesando */}
                <LoadingDialog titulo={traducirLabel(240)} abierto={true} />
            </>
        }
    </>)
};

export default AgregarContacto;
